<template>
  <div class="animated fadeIn">
    <basic-heading title="">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
  </div>
</template>

<script>
import BasicHeading from "../../../components/shared/BasicHeading";

export default {
  name: "PrepWorkflowManageInstrumentInstances",
  components: {
    BasicHeading,
  },
  data() {
    return {};
  },
  computed: {
    /**
     * Header button configuration
     */
    button_config() {
      return {};
    },
  },
};
</script>
